import {
  Component,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Location, isPlatformBrowser } from '@angular/common';
import { GoogleTagManagerService } from 'src/app/modules/shared/services/google-tag-manager.service';
import { Product } from 'src/app/modules/shared/models/products.model';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { LocalStorageService } from 'src/app/modules/shared/services/storage/local-storage.service';
import { FACEBOOK_EVENT_TYPES } from 'src/app/modules/shared/services/meta-pixel/meta-pixel.model';
import { MetaPixelService } from 'src/app/modules/shared/services/meta-pixel/meta-pixel.service';

@Component({
  selector: 'product-header',
  templateUrl: './product-header.component.html',
  styleUrls: ['./product-header.component.scss'],
})
export class ProductHeaderComponent implements OnInit {
  @Input() product: Product;
  @Input() showBackButton: boolean = true;
  productUrl: string;
  platformId: Object;
  @ViewChild('share') share: any;

  constructor(
    private location: Location,
    private router: Router,
    private googleTagManagerService: GoogleTagManagerService,
    private bottomSheet: MatBottomSheet,
    private panelService: PanelService,
    private localStorageService: LocalStorageService,
    private metaPixelService: MetaPixelService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.platformId = platformId;
    this.productUrl = isPlatformBrowser(this.platformId)
      ? window.location.href
      : '';
  }

  ngOnInit(): void {}

  handleFavClick() {
    this.toggleLike(!this.product.is_favorite);
  }

  goBack() {
    const previousUrl = document.referrer;

    if (
      previousUrl &&
      previousUrl.startsWith(window.location.origin) &&
      !previousUrl.includes('authenticate')
    ) {
      this.location.back();
    } else {
      this.router.navigate(['/']);
    }
  }

  sendShareEvent(type: 'email' | 'copy') {
    this.googleTagManagerService.sendAnalytics('share', {
      item_id: this.product.id,
      item_name: this.product.name,
      currency: this.product.currency_detail.code,
      type,
    });
  }

  shareWithMail() {
    if (this.productUrl) {
      this.sendShareEvent('email');
      const emailSubject = 'Check out this link!';
      const emailBody = `${this.productUrl}`;
      window.open(`mailto:?subject=${emailSubject}&body=${emailBody}`);
    }
  }

  shareProduct() {
    this.bottomSheet.open(this.share);
  }

  toggleLike(favStatus: boolean) {
    favStatus
      ? this.addToFavorite(this.product.id)
      : this.removeFromFavorite(this.product.id);
  }

  private addToFavorite(productId) {
    if (!this.localStorageService.isLoggedIn) {
      this.router.navigate(['/authenticate/login'], {
        queryParams: {
          access: 'false',
          product: this.product.id,
          name: this.product?.name,
        },
      });
      return;
    }

    this.panelService.addToFavorite(productId).subscribe((data) => {
      let analyticData = {
        currency: data?.product_detail?.currency_detail?.symbol,
        value: data.id,
        items: [
          {
            item_id: data?.product_detail.id,
            item_name: data?.product_detail?.name,
            currency: data?.product_detail?.currency_detail?.symbol,
            discount: data?.product_detail?.store_product_detail?.discount,
            cashback: data?.product_detail?.store_product_detail?.cashback,
            ...this.googleTagManagerService.setAnalyticItemCategories(
              data?.product_detail?.categories
            ),
          },
        ],
      };

      // analyticData[this.showCustomPriceField ? 'price_range' : 'price'] = this
      //   .showCustomPriceField
      //   ? this.customPlaceHolder
      //   : 'test';
      // if (!this.showCustomPriceField) delete analyticData['price'];

      // this.googleTagManagerService.sendAnalytics(
      //   'add_to_wishlist',
      //   analyticData
      // );
      this.metaPixelService.pushEvent(FACEBOOK_EVENT_TYPES.ADD_TO_WISHLIST, {
        data: {
          content_ids: [`${productId}`],
          contents: [
            {
              id: `${productId}`,
              quantity: 1,
            },
          ],
          currency: this.product.currency_detail.symbol,
          value: 1,
        },
      });
      this.product.is_favorite = true;
    });
  }

  private removeFromFavorite(productId) {
    if (!this.localStorageService.isLoggedIn) {
      return;
    }

    this.panelService.deleteFromFavorite(productId).subscribe((data) => {
      // let analyticData = {
      //   currency: this.product?.currency_detail?.symbol,
      //   value: 'null',
      //   items: [
      //     {
      //       item_id: this.product.id,
      //       item_name: this.product?.name,
      //       currency: this.product?.currency_detail?.symbol,
      //       discount: this.product?.store_product_detail?.discount,
      //       cashback: this.product?.store_product_detail?.cashback,
      //       ...this.googleTagManagerService.setAnalyticItemCategories(
      //         this.product?.categories
      //       ),
      //     },
      //   ],
      // };

      // analyticData[this.showCustomPriceField ? 'price_range' : 'price'] = this
      //   .showCustomPriceField
      //   ? this.customPlaceHolder
      //   : '';
      // if (!this.showCustomPriceField) delete analyticData['price'];
      // this.googleTagManagerService.sendAnalytics(
      //   'remove_from_wishlist',
      //   analyticData
      // );
      this.product.is_favorite = false;
    });
  }
}
